import { Component, OnInit } from '@angular/core';
import { faChevronRight, faTimes } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ModifyContactBookingComponent } from '../../pages/trips/modify-contact-booking/modify-contact-booking.component';
import { ModifyDateBookingComponent } from '../../pages/trips/modify-date-booking/modify-date-booking.component';

@Component({
  selector: 'app-modify-booking',
  templateUrl: './modify-booking.component.html',
  styleUrls: ['./modify-booking.component.scss']
})
export class ModifyBookingComponent implements OnInit {
  icons = {
    cancel: faTimes,
    chevronRight: faChevronRight
  }
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    public options: ModalOptions

  ) {
   }

  ngOnInit(): void {
    // console.log(this.options)
  }

  onEditContact(): void {
    this.bsModalRef?.hide()
    const initialState = { edit: true, person: this.options?.initialState?.person, booking: this.options?.initialState?.booking}

    const options: any = {initialState, class: 'modal-rounded' }

    this.bsModalRef =  this.modalService.show(ModifyContactBookingComponent, options)
  }
  onEditDate(): void {
    this.bsModalRef?.hide()
    const initialState = { edit: true, data: this.options?.initialState?.data, booking: this.options?.initialState?.booking}

    const options: any = {initialState, class: 'modal-rounded' }

    this.bsModalRef =  this.modalService.show(ModifyDateBookingComponent, options)
  }

}
